import { ContainedButton, FormInputText } from 'secondstep-components'
import styled from 'styled-components'
import { themeGet } from 'styled-system'
import {
  ModalHeaderInput,
  ModalWrapperInput,
  ButtonsWrapper,
  CancelButton,
} from '../../component.styles'

const ERROR_RED = '#b8002f'

export const ModalWrapperAddInstructor = styled(ModalWrapperInput).attrs(
  () => ({
    size: 'small',
  }),
)`
  align-items: stretch;
  padding: 2.125rem 1.6875rem 2.5rem;
  text-align: left;
  width: 30.313rem;
  max-width: 100%;

  ${ModalHeaderInput} {
    color: ${themeGet('colors.secondStepBlue')};
    display: flex;
    font-family: ${themeGet('font.sharpSlab.semibold')};
    font-size: 1.625rem;
    justify-content: center;
    margin-bottom: 0.375rem;
    text-align: center;
    width: 100%;
  }
`

export const HelperText = styled.p`
  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('font.molde.regular')};
  font-size: 1rem;
  line-height: 1.375rem;
  margin: 0 0 0.375rem;
`

export const EmailEntry = styled.div`
  margin-bottom: 1rem;
  width: 100%;

  /* FormField default bottom margin creates a gap before the error box */
  [class*='FormField'],
  [data-testid^='form-field-'] {
    margin-bottom: 0;
  }

  label {
    font-family: ${themeGet('font.molde.medium')};
  }

  /* Hide FormField's built-in error — we render LookupErrorBox instead */
  [data-testid='error-message'] {
    display: none;
  }

  ${({ $hasError }) =>
    $hasError &&
    `
    input {
      border: 0.125rem solid ${ERROR_RED} !important;
      box-shadow: none !important;
    }
  `}
`

export const StyledFormInputText = styled(FormInputText)`
  padding-bottom: 0;
  width: 100%;
`

export const LookupErrorBox = styled.div`
  background: ${themeGet('colors.white')};
  border: 0.0625rem solid ${ERROR_RED};
  border-radius: 0.3125rem;
  box-sizing: border-box;
  margin-top: 0.25rem;
  padding: 0.438rem 0.6875rem;
  width: 100%;

  p {
    color: #555;
    font-family: ${themeGet('font.molde.regular')};
    font-size: 1rem;
    line-height: 1.375rem;
    margin: 0;
  }
`

export const PeopleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
`

export const PeopleLabel = styled.p`
  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('font.molde.medium')};
  font-size: 1rem;
  line-height: 1.375rem;
  margin: 0;
`

export const PersonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const PersonInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

export const Avatar = styled.div`
  align-items: center;
  background: linear-gradient(180deg, #e77564 0%, #c94b3a 100%);
  border-radius: 50%;
  color: ${themeGet('colors.white')};
  display: flex;
  flex-shrink: 0;
  font-family: ${themeGet('font.sharpSlab.semibold')};
  font-size: 1rem;
  height: 2.125rem;
  justify-content: center;
  letter-spacing: 0.058rem;
  width: 2.125rem;
`

export const PersonText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;

  .name {
    color: ${themeGet('colors.darkGray')};
    font-family: ${themeGet('font.molde.medium')};
    font-size: 1rem;
    line-height: 1.375rem;
  }

  .email {
    color: ${themeGet('colors.darkGray')};
    font-family: ${themeGet('font.molde.regular')};
    font-size: 1rem;
    line-height: 1.375rem;
  }
`

export const PersonRole = styled.span`
  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('font.molde.regular')};
  font-size: 1rem;
  line-height: 1.375rem;
  text-align: right;
`

export const StyledButtonsWrapper = styled(ButtonsWrapper)`
  position: relative;
  bottom: 0;
  left: 0;
  justify-content: center;
  margin: 0;
  transform: none;
  width: 100%;
`

export const ShareButton = styled(ContainedButton)`
  max-width: 9.375rem;
  width: 50%;
`

export const AddInstructorCancelButton = styled(CancelButton)`
  max-width: 9.375rem;
  width: 50%;
`

export { ModalHeaderInput }
